export const GET_ALL_DNS_RECORD = "GET_ALL_DNS_RECORD";
export const START_LOADING_DNS_RECORD = "START_LOADING_DNS_RECORD";
export const STOP_LOADING_DNS_RECORD = "STOP_LOADING_DNS_RECORD";
export const ERROR_LOADING_DNS_RECORD = "ERROR_LOADING_DNS_RECORD";
export const RESET_DATA = "RESET_DATA";